module.exports = __webpack_public_path__ + "img/lock.42bcd6f9.svg";